import { Injectable } from '@angular/core';
import { IIssueStateWorkflow } from '@common/interfaces/issueStateWorkflow';
import { Topics } from '@common/interfaces/topics';
import { ActionService } from '../action/action.service';
import { CrudService } from '../crudService';
import { BaseEntityStoreStrategy } from '../updateStoreStrategies';
import { IssueStateWorkflowQuery } from './issueStateWorkflow.query';
import { IssueStateWorkflowStore } from './issueStateWorkflow.store';

@Injectable({
  providedIn: 'root'
})
export class IssueStateWorkflowService extends CrudService<IIssueStateWorkflow, IssueStateWorkflowStore, IssueStateWorkflowQuery> {

  constructor(
    protected store: IssueStateWorkflowStore,
    public query: IssueStateWorkflowQuery,
    protected actionService: ActionService,
    protected updateStrategy: BaseEntityStoreStrategy,
  ) {
    super(
      Topics.ISSUE_STATE_WORKFLOWS,
      store,
      query,
      actionService,
      updateStrategy
    );
  }

  
}
